import { yupResolver } from '@hookform/resolvers/yup';
import { useState, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import * as Yup from 'yup';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Button } from '../button/button';
import { Fieldset } from '../fieldSet/fieldSet';
import { Form } from '../form/form';
import { TextInput } from '../form/textInput';
import { InviteRecruiter } from '../inviteRecruiter/inviteRecruiter';
import { Wizard } from '../wizard/wizard';
import { MdPersonAdd as AddUserIcon } from 'react-icons/md';
import styles from './addRecruiterForm.module.scss';
import { Section } from '@components/section/section';
import { baseUrl } from 'constants/baseUrl';
import storageService from '@services/storageService';

const inviteSchema = Yup.object({
  email: Yup.string().email('Invalid email').required('Email is required'),
});

export const AddRecuriterForm = () => {
  const [inviting, setInviting] = useState(false);
  const [activeWorkspace, setActiveWorkspace] = useState(null);

  useEffect(() => {
    const fetchActiveWs = async () => {
      try {
        const res = await axios.get(`${baseUrl}/rest/workspaces/my-workspaces`, {
          headers: {
            AuthAPI: `Bearer ${storageService.getToken()}`,
            Device: 'TMR',
          },
        });
        const list = res.data?.data?.workspaces || [];
        const currentId = localStorage.getItem('active_workspace_id');
        const found = list.find((w) => String(w.id) === String(currentId)) || list[0];
        setActiveWorkspace(found);
      } catch (e) {
        console.error(e);
      }
    };
    fetchActiveWs();
  }, []);

  const form = useForm({
    resolver: yupResolver(inviteSchema),
    mode: 'all',
    defaultValues: {},
    shouldUnregister: true,
  });

  const submitForm = async (values) => {
    if (!values.email) {
      toast.error('Please enter an email address.');
      return;
    }
    setInviting(true);
    try {
      const workspaceId = localStorage.getItem('active_workspace_id');
      const res = await axios.post(
        `${baseUrl}/rest/workspaces/invite`,
        { email: values.email },
        {
          headers: {
            AuthAPI: `Bearer ${storageService.getToken()}`,
            Device: 'TMR',
            ...(workspaceId ? { 'X-TMR-Workspace-Id': workspaceId } : {}),
          },
        }
      );
      if (res.data?.success) {
        toast.success(res.data?.messages || 'Invitation sent!');
        form.reset();
      } else {
        toast.error(res.data?.errors || 'Failed to invite.');
      }
    } catch (err) {
      const msg = err.response?.data?.errors || err.response?.data?.message || 'Failed to invite user.';
      toast.error(msg);
    } finally {
      setInviting(false);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
      <Wizard
        step={1}
        title={'Invite a recruiter to your workspace'}
        formName="addRecruiterForm"
        icon={<AddUserIcon size={25} />}
      >
        <Section
          title={'Invite by email'}
          headingSize="large"
          contentVisible={true}
        />
        {activeWorkspace?.workspace_type === 'personal' ? (
          <div className="p-4 text-center">
            <p className="text-muted" style={{ fontSize: '15px', lineHeight: '1.6' }}>
              Team invitations are not available in Personal TMR. Switch to a TMR Organization to collaborate with team members.
            </p>
          </div>
        ) : (
          <FormProvider {...form}>
            <Form onSubmit={form.handleSubmit(submitForm)}>
              <Fieldset className={styles.formRecruiterWrapper}>
                <InviteRecruiter avatar={null} />
                <TextInput placeHolder="Email address" name="email" type="email" />
                <div className="py-3">
                  <Button type="submit" important disabled={inviting}>
                    {inviting ? 'Inviting...' : 'Add and send invite'}
                  </Button>
                </div>
              </Fieldset>
            </Form>
          </FormProvider>
        )}
      </Wizard>
    </div>
  );
};
